import * as React from 'react';

import {
  StyledBody,
  StyledBodyContainer,
  StyledBodyCopy,
  StyledCard,
  StyledContent,
  StyledDirectCta,
  StyledHeadline,
  StyledImage,
  StyledImageWrap,
} from './card.styles';

export type CardProps = {
  to: string;
  headline: string;
  image?: string;
  text?: string | React.ReactNode;
  onClick?: (ev: React.MouseEvent<HTMLElement>) => void;
  style?: 'default' | 'direct';
  linkLabel?: string | React.ReactNode;
};

export const Card: React.FC<React.PropsWithChildren<CardProps>> = ({
  image,
  text,
  headline,
  onClick,
  linkLabel,
  to,
}) => {
  const openTo = React.useCallback(
    (ev: React.MouseEvent<HTMLElement>) => {
      if (ev.isPropagationStopped()) {
        return;
      }
      if (onClick) {
        onClick(ev);
      }
      window.open(to, '_blank');
    },
    [to, onClick]
  );

  return (
    <StyledCard>
      <StyledImageWrap
        style={{ backgroundImage: `url(${image})` }}
        onClick={openTo}
      >
        <StyledImage src={image} alt="" />
      </StyledImageWrap>
      <StyledBodyContainer>
        <StyledBody>
          <StyledContent>
            <StyledHeadline onClick={openTo} size="medium">
              {headline}
            </StyledHeadline>

            <StyledBodyCopy onClick={openTo}>{text}</StyledBodyCopy>
          </StyledContent>
          <StyledDirectCta href={to} target="_blank" onClick={onClick}>
            {linkLabel}
          </StyledDirectCta>
        </StyledBody>
      </StyledBodyContainer>
    </StyledCard>
  );
};
